import React, {useState, useEffect, useMemo, useCallback} from 'react';
import { useAppDispatch } from '../../../stores/hook';
import PackModal from './Modals/PackModal';
import { setDetailInfoId, setPackInfoDetailStatus, setPackInfo, setSubscribeModalStatus, setIsTvBoxPage, setIsBoxPlan  } from './GetStartedSlice';
import { useParams, Link } from 'react-router-dom';
import { fetchBoxDetailsPlan,  getPackInfoById } from '../../functions/fetchGetStarted';
import { SOURCE_URL } from '../../../config';
import translations from '../../../text/get-started-translations.json';
import language from '../../../utils/LanguageSettings';
import SubscribeModal from './Modals/SubscribeModal/SubscribeModal';
import { IPriceOption, PackInfo} from '../types';
import { STB } from '../constants';
import ImageFallback from '../../../utils/ImageFallback';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import defaultImgSquare from '../../../images/icon/default-img-square.png'
import defaultImgBanner from '../../../images/icon/default-img-banner.png'
import { custTypeMapping } from '../../functions/filterCustomerTypeDisplay';
import RenderSnA from '../../functions/renderSnA';
interface BoxPlanDetailProps {
    // className?: string;
    // combopacks: any[];
}

const BoxPlanDetail: React.FC<BoxPlanDetailProps> = () => {
    const pageTranslations = translations[language]; // Select the correct translations
    const id = useParams();
    const [comboPacks, setComboPacks] = useState<any>([]);
    const [targetPlan, setTargetPlan] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const dispatch = useAppDispatch();
    const packs = useMemo<any[]>(() => [], []);
    const link = window.myAppStrapi && window.myAppStrapi.phpButtonLink ? window.myAppStrapi.phpButtonLink : '';
    const campaignCodes = window.myAppStrapi && window.myAppStrapi.campaignCodeArray ? window.myAppStrapi.campaignCodeArray : {};
    const campaignCodeMap = new Map(Object.entries(campaignCodes));
    let custType = window.myAppStrapi && window.myAppStrapi.cust_type;
    let loginUrl = window.myAppStrapi && window.myAppStrapi.login_url;
    const [seo, setSeo] = useState<any>(null);
    const [ga, setGa] = useState<any>(null);

    const fetchPackInfoData = useCallback(async (id: string) => {
        const data = await getPackInfoById(id, language);
        if (data && !packs.some((item: { combopack: { id: string; } }) => item?.combopack?.id === id)) {
            packs.push(data);
        }
    }, [packs]);

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchBoxDetailsPlan(language);
            if (data) {
                for (let i = 0; i < data.plans.length; i++) {
                    if (data.plans[i]?.attributes?.stb_detail_id === id.id) {
                        setTargetPlan(data.plans[i]);
                        setSeo({"Title": data.plans[i]?.attributes?.name,
                                "MetaDescription" : data.plans[i]?.attributes?.description === null ? '' : data.plans[i]?.attributes?.description?.slice(0,100),
                                "MetaKeywords": data.plans[i]?.attributes?.name,
                                "MetaImage": SOURCE_URL + data.plans[i]?.attributes?.plan_img?.data?.attributes?.url});
                        for (let j = 0; j < data.plans[i]?.attributes?.includes?.data.length; j++) {
                            await fetchPackInfoData(data.plans[i]?.attributes?.includes?.data[j].id + '');
                        }
                        setComboPacks(packs);
                        break;
                    }
                }
            }
            setLoading(false);
        };
        fetchData();
    }, [fetchPackInfoData, id.id, packs]);


    const onClickBtn = (e:React.MouseEvent<HTMLButtonElement>, packInfo: PackInfo) => {
        if (custTypeMapping[custType] == "User Type 1 (Not Logged In)" && packInfo.PriceOptions && packInfo.PriceOptions.length === 1) {
            window.location.href = loginUrl;
        } else if (packInfo.PriceOptions && packInfo.PriceOptions.length > 1) {
            dispatch(setSubscribeModalStatus(true));
            // store the price when click
            dispatch(setPackInfo(packInfo));
            dispatch(setIsTvBoxPage(true));
            if(!targetPlan?.attributes?.CustomerTypeDisplay?.DisplayType || !targetPlan?.attributes?.CustomerTypeDisplay?.DisplayType.includes(custTypeMapping[custType])){
                dispatch(setIsBoxPlan(true));
            }
        } else if (packInfo.PriceOptions && packInfo.PriceOptions.length === 1) {
            if (packInfo.PriceOptions[0].Campaign) {
                if (campaignCodeMap.size > 0) {
                    const cpm = campaignCodeMap.get(packInfo.PriceOptions[0].Campaign);
                    const d = new Date();
                    d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
                    const expires = "expires=" + d.toUTCString();
                    document.cookie = "cpm=" + cpm + ";" + expires + ";SameSite=None;Secure;domain=.nowtv.now.com;path=/";
                    window.location.href = link;
                }
                    
            }
        }
    }

    const filteredPriceOptions = useMemo(() => {
        const tmpFilteredPriceOptions = [] as IPriceOption[]
        if (targetPlan?.attributes?.PriceOptionsSTB && targetPlan?.attributes?.PriceOptionsSTB.length > 0) {
            targetPlan?.attributes?.PriceOptionsSTB.forEach((priceOption: IPriceOption) => {
              if (typeof priceOption.Price === 'number' && priceOption.Price >= 0) {
                tmpFilteredPriceOptions.push(priceOption)
              }
            })
        }
          return tmpFilteredPriceOptions
      }, [targetPlan?.attributes?.PriceOptionsSTB])
    
      const buttonText = useMemo(
        () => {
          if (filteredPriceOptions && filteredPriceOptions.length > 1) {
            return pageTranslations.SeeOptions;
          } else {
            return pageTranslations.SubscribeNow;
          }
        }, [filteredPriceOptions])
    
      const priceText = useMemo(
        () => {
            if (filteredPriceOptions && filteredPriceOptions.length === 1) {
                return filteredPriceOptions[0].Type === 'Yearly' ? `${filteredPriceOptions[0].Price / 12}` : filteredPriceOptions[0].Price;
            } else if (filteredPriceOptions && filteredPriceOptions.length > 1) {
                let priceOption = {
                    priceText: ""
                };
                switch (filteredPriceOptions[0].Type) {
                    case "Yearly":
                      priceOption.priceText = `<span>${pageTranslations.From}</span> $${(filteredPriceOptions[0].Price / 12).toLocaleString("zh-HK")}<span> / ${pageTranslations.MonthThen}</span>`;
                      break;
                    case "Monthly":
                      priceOption.priceText = `<span>${pageTranslations.From}</span> $${filteredPriceOptions[0].Price}<span> / ${pageTranslations.MonthThen}</span>`;
                      break;
                    case "Daily":
                      priceOption.priceText = `$${filteredPriceOptions[0].Price}<span> / ${pageTranslations.day}</span>`;
                      break;
                    case "Event":
                      priceOption.priceText = `$${filteredPriceOptions[0].Price}<span> / ${pageTranslations.EventPass}</span>`;
                      break;
                }
                return priceOption.priceText;
            }
          return ''
        }, [filteredPriceOptions])

    const fillPackItem = () => {
        return Array.isArray(comboPacks) && comboPacks.map((item, index) => (
            <div className="light-gray-bg combo-box-wrap mb-5 hid-overflow" key={index}>
                <div className="row no-gutters hid-overflow">
                    <div className="col-lg-4 fadeInLeft pack-image-col d-lg-block d-none animated">
                        <div className="with-slanting-border h-100 object-item" data-imgposition="center center">
                            <ImageFallback
                                primarySrc={item?.combopack?.attributes?.packSquareImage?.data?.attributes?.formats?.small?.url ? `${SOURCE_URL}` + item?.combopack?.attributes?.packSquareImage?.data?.attributes?.formats?.small?.url : ''}
                                defaultSrc={defaultImgSquare}
                                alt="Pack image"
                                className="w-100 h-100 img-fit object-desktop-image ls-is-cached lazyloaded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-4 fadeInLeft pack-image-col d-lg-none d-block animated">
                        <div className="with-slanting-border h-100">
                            <ImageFallback
                                primarySrc={item?.combopack?.attributes?.packImage?.data?.attributes?.formats?.large?.url ? `${SOURCE_URL}` + item?.combopack?.attributes?.packImage?.data?.attributes?.formats?.large?.url : ''}
                                defaultSrc={defaultImgSquare}
                                alt="Pack image"
                                className="w-100 h-100 img-fit object-desktop-image ls-is-cached lazyloaded"
                            />
                        </div>
                    </div>
                    <div className="col-lg-8 fadeInLeft py-lg-5 py-4 pr-lg-5 pr-4 pl-4 animated">
                        <div className="row align-items-center">
                            <div className="col-sm-8 text-sm-left text-center">
                                <h3 className="font-medium">{item?.combopack?.attributes?.name}</h3>
                            </div>
                            <div className="col-sm-4 text-sm-right text-center">
                                <a onClick={() => handleClick(item?.combopack?.id)} className="barlow-font color-1 arrowed-link" role="button" tabIndex={0}>{pageTranslations.SeeDetails}<i className="icon-angle-right"></i></a>
                            </div>
                        </div>
                        <p className="lg_font_size light-gray py-4 text-sm-left text-center">
                            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{item?.combopack?.attributes?.description}</ReactMarkdown>
                        </p>
                        <div className="featured-logo-label py-3 text-sm-left text-center" key={index}>
                            {((item?.combopack?.attributes?.onDemandNumber?.data?.length || item?.combopack?.attributes?.channelsNumber?.data?.length) && language.indexOf("zh") > -1) ? pageTranslations.Including : ''}
                            {(item?.combopack?.attributes?.onDemandNumber?.data?.length ? item?.combopack?.attributes?.onDemandNumber?.data?.length + pageTranslations.OnDemandCatalogs : '')}
                            {(item?.combopack?.attributes?.onDemandNumber?.data?.length && item?.combopack?.attributes?.channelsNumber?.data?.length) ? pageTranslations.And : ''}
                            {(item?.combopack?.attributes?.channelsNumber?.data?.length ? item?.combopack?.attributes?.channelsNumber?.data?.length + pageTranslations.Channels : '')}
                            {((item?.combopack?.attributes?.onDemandNumber?.data?.length || item?.combopack?.attributes?.channelsNumber?.data?.length) && language.indexOf("en") > -1) ? pageTranslations.Including :
                                (item?.combopack?.attributes?.onDemandNumber?.data?.length || item?.combopack?.attributes?.channelsNumber?.data?.length) ? ':' : ''}
                        </div>
                        <div className="row pt-sm-4 pt-5 text-center align-items-center">
                            {fillChannel([...item?.combopack?.attributes?.channelsNumber?.data, ...item?.combopack?.attributes?.onDemandNumber?.data])}
                        </div>
                    </div>
                </div>
            </div>
        ))
    }

    const fillChannel = (channelList: any) => {
        if (channelList.length > 4) {
            channelList = channelList.slice(0, 4);
        }
        return Array.isArray(channelList) && channelList.map((item, index) => (
            <div className="col-sm-3 col-6 mb-sm-0 mb-5" key={index}>
                <ImageFallback
                      primarySrc={item?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url ? `${SOURCE_URL}` + item?.attributes?.icon?.data?.attributes?.formats?.thumbnail?.url : item?.attributes?.icon?.data?.attributes?.url ? `${SOURCE_URL}` + item?.attributes?.icon?.data?.attributes?.url : ''}
                      alt="Filter Icon"
                      className="img-fluid featured-logo lazyloaded"
                />
            </div>
        ))
    }

    const handleClick = (id: string) => {
        dispatch(setDetailInfoId(id));
        dispatch(setPackInfoDetailStatus(true));
    }

    const fillImage = (url1: string, url2: string) => {
        return (<>
           <ImageFallback
                primarySrc={url1 ? `${SOURCE_URL}` + url1 : ''}
                defaultSrc={defaultImgBanner}
                alt="Plan image"
                className="object-desktop-image w-100 d-lg-block d-none lazyloaded"
            />
            <ImageFallback
                primarySrc={url2 ? `${SOURCE_URL}` + url2 : ''}
                defaultSrc={defaultImgSquare}
                alt="Plan image"
                className="object-mobile-image w-100 d-lg-none d-block lazyloaded"
            />
        </>);
    }

    if (loading) {
        return (<>
            <div id="loader">
                <div className="spinner-border"></div>
            </div>
        </>
        );
    }

    if (targetPlan.length === 0) {
        return (<>
            <RenderSnA seo={seo} ga={ga} />
            <div className="container-fluid spacer text-center" id="error">
                <h2>
                    <span>{pageTranslations.Oops}</span>
                </h2>
                <h4>{pageTranslations.NotFoundMessage}</h4>
                <p>&nbsp;</p>
                <Link to="https://www.nowtv.now.com" className="default-btn my-5">{pageTranslations.GoBackToHome}</Link>
                <div className="topic-row justify-content-center">
                    <div className="col-lg-2-5 col-md-4">
                        <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/">{pageTranslations.Home}</Link>
                    </div>
                    <div className="col-lg-2-5 col-md-4">
                        <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/get-started/">{pageTranslations.GetStarted}</Link>
                    </div>
                    <div className="col-lg-2-5 col-md-4">
                        <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://www.nowtv.now.com/support/">{pageTranslations.Support}</Link>
                    </div>
                    <div className="col-lg-2-5 col-md-4">
                        <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://nowplayer.now.com/">{pageTranslations.Watch}</Link>
                    </div>
                    <div className="col-lg-2-5 col-md-4">
                        <Link className="boxed-link px-2 d-flex lg_font_size color-5 py-3" to="https://nowplayer.now.com/tvguide">{pageTranslations.TVGuide}</Link>
                    </div>
                </div>
            </div>
        </>
        );
    } else {
        return (
            <>
                <RenderSnA seo={seo} ga={ga} />
                <div className='combo-pack-template-default'>
                    <section id="inner-banner">
                        {fillImage(targetPlan?.attributes?.plan_img?.data?.attributes?.url, targetPlan?.attributes?.plan_square_img?.data?.attributes?.url)}
                    </section>
                    <section className="spacer-top combo-desc">
                        <div className="container">
                            <div className="combo-box-wrap p-md-5 p-4 fadeInUp animated">
                                <div className="row">
                                    <div className="col-md-7 text-md-left text-center">
                                        <h1 className="h3 font-medium mb-4">{targetPlan?.attributes?.name}</h1>
                                        <p className="light-gray brief-desc">
                                            <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{targetPlan?.attributes?.description}</ReactMarkdown>
                                        </p>
                                    </div>
                                    <div className="col-md-5 text-md-right text-center bottom-control">
                                        <div className="price-wrap">
                                        {
                                            filteredPriceOptions && filteredPriceOptions.length > 1 && (
                                            <h3 className="price"> 
                                                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{p: React.Fragment,}}>{priceText+""}</ReactMarkdown>                                           
                                            </h3>
                                            )
                                        }
                                        {
                                            filteredPriceOptions && filteredPriceOptions.length === 1 && (
                                            <h3 className="price">
                                                ${priceText + ' '}
                                                {(filteredPriceOptions[0].Type === 'Monthly' || filteredPriceOptions[0].Type === 'Yearly') && <span> {`/ ${pageTranslations.Month2}`}</span>}
                                                {filteredPriceOptions[0].Type === 'Event' && <span>/ {pageTranslations.EventPass}</span>}
                                                {filteredPriceOptions[0].Type === 'Daily' && <span>/ {pageTranslations.day}</span>}
                                            </h3>
                                            )
                                        }
                                        <small>{targetPlan?.attributes?.feeExtraDescription}</small>
                                        </div>
                                        {(targetPlan.attributes?.PriceOptionsSTB && targetPlan.attributes?.PriceOptionsSTB.length > 1) || 
                                        ( targetPlan.attributes?.PriceOptionsSTB && targetPlan.attributes?.PriceOptionsSTB.length === 1 &&
                                        (!targetPlan?.attributes?.CustomerTypeDisplay?.DisplayType || targetPlan?.attributes?.CustomerTypeDisplay?.DisplayType.includes(custTypeMapping[custType])) || 
                                        ( targetPlan.attributes?.PriceOptionsSTB && targetPlan.attributes?.PriceOptionsSTB.length === 1 && custTypeMapping[custType] == "User Type 1 (Not Logged In)")) ?
                                        <div className="cta-buttons">
                                            <button onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                        const packInfo: PackInfo = { 
                                                            name: targetPlan.attributes.name,
                                                            PriceOptions: targetPlan.attributes?.PriceOptionsSTB,
                                                            optionsContext: targetPlan.attributes.optionsContext
                                                        };
                                                        onClickBtn(e, packInfo);
                                                    }
                                                } 
                                            className="btn primary subscribe-now" stb-campaign={targetPlan?.attributes?.stb_campaign}>{buttonText}</button>
                                        </div> : <></>
                                            }
                                    </div>
                                   
                                    {/* <div className="col-md-5 text-md-right text-center">
                                        <h3 className="monthly-rate mb-md-4 mb-2 font-medium mt-md-0 mt-5">${targetPlan?.attributes?.stb_price}<span>/ {pageTranslations.Month}</span></h3>
                                        <button onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                                    const packInfo: PackInfo = { 
                                                        name: targetPlan.attributes.name,
                                                        PriceOptions: targetPlan.attributes?.PriceOptions,
                                                        optionsContext: targetPlan.attributes.optionsContext
                                                    };
                                                    onClickBtn(e, packInfo);
                                                }
                                            } 
                                        className="btn primary subscribe-now" stb-campaign={targetPlan?.attributes?.stb_campaign}>{buttonText}</button>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </section>
                    <section id="package-included">
                        <div className="introduction-text-box text-center spacer fadeInUp animated">
                            <h3 className="font-medium">{pageTranslations.IncludesThese} <span className="color-4">{targetPlan?.attributes?.includes?.data?.length} {pageTranslations.Packs}</span></h3>
                        </div>
                        <div className="container-fluid-box">
                            {fillPackItem()}
                        </div>
                        <PackModal />
                    </section>
                    <SubscribeModal />
                </div>
            </>
        );
    }
};

export default BoxPlanDetail;